<template>
    <div class="fixed pointer-events-none space-y-1.5">
        <TransitionGroup
            enter-from-class="opacity-0 -translate-x-full"
            enter-to-class="opacity-100 translate-x-0"
            enter-active-class="transition-all duration-200 ease-in-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0 scale-[1.15]"
            leave-active-class="transition-all duration-200 ease-in-out"
            move-class="transition-all duration-200 ease-in-out"
        >
            <div
                v-for="toast in toasts"
                :key="toast.id"
                class="relative isolate p-4 flex gap-x-3 bg-white dark:bg-logo-500 border border-neutral-200 dark:border-logo-600 rounded-xl overflow-hidden pointer-events-auto"
            >
                <div class="absolute top-2 right-2 z-10">
                    <button
                        class="button button-sm button-icon button-ternary"
                        @click="clear(toast)"
                    >
                        <Icon
                            name="icon-close"
                            class="w-6 h-6"
                        />
                    </button>
                </div>

                <Icon
                    :name="toast.icon"
                    class="m-auto w-12 h-12 text-font-primary dark:text-font-light flex-none"
                />

                <div class="">
                    <h4 class="text-font-primary dark:text-font-light font-semibold leading-none">
                        {{ toast.title }}
                    </h4>

                    <div
                        class="mt-2 text-sm text-font-secondary dark:text-font-light leading-tight"
                        v-html="toast.text"
                    />
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script setup>
    import { ref, onBeforeUnmount, onMounted } from 'vue';
    import bus from '/src/utils/bus.js';

    defineOptions({
        name: 'AppToasts',
    });

    const props = defineProps({
        duration: {
            type: Number,
            default: 5000,
        },
    });

    // toasts
    const toasts = ref([]);
    function add ({ id, title, text, icon, duration = props.duration }) {
        const toast = {
            id: id ?? new Date().getTime(),
            title,
            text,
            icon,
            duration,
        };

        if (duration > 0) {
            toast.timer = setTimeout(() => {
                clear(toast);
            }, duration);
        }

        toasts.value.push(toast);
    }
    function clear (toast) {
        clearTimeout(toast.timer);
        const index = toasts.value.findIndex(t => t.id === toast.id);

        if (index >= 0) {
            toasts.value.splice(index, 1);
        }
    }

    // listeners
    onMounted(() => {
        bus.on('toasts:add', add);
        bus.on('toasts:clear', clear);
    });
    onBeforeUnmount(() => {
        bus.off('toasts:add', add);
        bus.off('toasts:clear', clear);
        toasts.value.forEach(toast => clearTimeout(toast.timer));
    });
</script>
